import { useEffect, useMemo } from 'react';
import axios from 'axios';
import { isBefore } from 'date-fns';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_GATEWAY,
});

api.postOrPut = (url, id, data, config = {}) => {
  const method = id ? 'put' : 'post';
  const apiUrl = id ? `${url}/${id}` : `${url}/r`;
  return api[method](apiUrl, data, config);
};

export function GlobalApiInterceptors({ isAuthenticated }) {
  const history = useHistory();
  const interceptors = useMemo(
    () => ({
      request: async config => {
        const accessToken = localStorage.getItem('@TmovGR:access_token');
        const idToken = localStorage.getItem('@TmovGR:id_token');
        const expiry_date_refresh_token = localStorage.getItem(
          '@TmovGR:expiry.date_refresh_token'
        );

        if (
          expiry_date_refresh_token &&
          isBefore(new Date(expiry_date_refresh_token), Date.now())
        ) {
          localStorage.clear();
          history.push('/');
          return;
        }

        if (accessToken) config.headers.authorization = `Bearer ${accessToken}`;

        if (idToken) config.headers.userinfo = idToken;

        return config;
      },
      response: response => response,
      error: async error => {
        const req = error.request;

        if (!isAuthenticated) {
          return Promise.reject(error);
        }

        if (req?.status === 401) {
          localStorage.clear();
          history.push('/');
          return;
        }

        if (req?.status === 400 || req?.status === 404) {
          if (error?.response?.data?.message) {
            return error.response.data.message;
          }

          if (error?.respons?.data?.validation?.lenght > 0) {
            return error.response.data.validation.join();
          }
        }

        return Promise.reject(error);
      },
    }),
    [isAuthenticated, history]
  );

  useEffect(() => {
    const reqInterceptor = api.interceptors.request.use(
      interceptors.request,
      interceptors.error
    );
    const resInterceptor = api.interceptors.response.use(
      interceptors.response,
      interceptors.error
    );

    return () => {
      api.interceptors.request.eject(reqInterceptor);
      api.interceptors.response.eject(resInterceptor);
    };
  }, [interceptors]);

  return null;
}

GlobalApiInterceptors.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired
};

export default api;
